






























import {
  Component,
  Prop,
  Model,
  Watch,
  Mixins,
} from 'vue-property-decorator';
import FormMixin from '../../../common/mixins/formMixin';
import SearchBar from './searchBar.vue';
import SearchList from './searchList.vue';
import SearchBody from './searchBody.vue';
import { FitIcon } from '@tencent/wphk-ui';

@Component({
  components: {
    SearchBar,
    SearchList,
    SearchBody,
    FitIcon,
  },
})
export default class FitNation extends Mixins(FormMixin) {
  @Prop({ default: () => [] }) public data!: any[];
  @Prop({ default: () => [] }) public hotList!: any[];
  @Prop({ default: '' }) public placeholder!: string;
  @Prop({ default: '热门' }) public hotListTitle!: string;
  @Prop({ default: '全部' }) public searchTitle!: string;
  @Prop({ default: '搜索' }) public searchPlaceholder!: string;
  @Prop({ default: '取消' }) public cancelText!: string;
  @Prop({ default: false }) public disabled!: boolean;
  @Model('change') public readonly value!: string[] | number[];
  public label = '';
  public show = false;
  public onChange(value: any, item: any) {
    this.$emit('change', value, item);
    this.notify('change', value);
  }
  @Watch('value')
  public updateLabel() {
    const curItem = this.data.find(item => item.value.toLowerCase() === (`${this.value}`).toLowerCase());
    this.label = curItem ? curItem.label : null;
  }
  @Watch('data')
  public updateLabelWhenDataChange() {
    this.updateLabel();
  }
  public created() {
    this.updateLabel();
  }
  onClickNationSelect() {
    if (!this.disabled) {
      this.show = true;
    }
  }
}
